export function domainFromUrl(url?: string, fallback?: string): string {
  if (url) {
    try {
      return new URL(url).hostname;
    } catch {
      // ignore parse errors
    }
  }
  return fallback ?? '?';
}
